// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyB5JzpBCZuENpn7Q7qzjJKXdgWbQ_ESZq8",
  authDomain: "nmtindholidays.firebaseapp.com",
  databaseURL: "https://nmtindholidays-default-rtdb.firebaseio.com",
  projectId: "nmtindholidays",
  storageBucket: "nmtindholidays.firebasestorage.app",
  messagingSenderId: "681629478205",
  appId: "1:681629478205:web:8c942c2aa889a93775a954",
  measurementId: "G-LSMMHS43LX"
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);

// Initialize services
const db = getDatabase(firebaseApp);
const storage = getStorage(firebaseApp);

// Export the services
export { db, storage };